"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.76-.06H2.24a.56.56,0,0,0-.63.63V20.09a.56.56,0,0,0,.63.63H8.63l3.21,3.15a.22.22,0,0,0,.32,0l3.21-3.15h6.39a.56.56,0,0,0,.63-.63V.57A.56.56,0,0,0,21.76-.06Z",
    style: {
      fill: '#004864'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.07,11.41H19V8A2.06,2.06,0,0,0,17,5.92H15.6V7.29h2.06V9.35H15.6v2.06H12.86V4.89a.35.35,0,0,0-.35-.34H6.33a.34.34,0,0,0,0,.68H9.42A2.75,2.75,0,0,1,12.17,8v3.43H8.39V10H5.65v1.37H4.27A4.13,4.13,0,0,0,5.7,14.53c-.68.24-.22.84-1.42.84a.34.34,0,1,0,0,.68,2.12,2.12,0,0,0,1.54-.66,2.14,2.14,0,0,0,3.09,0,2.12,2.12,0,0,0,1.54.66A2.14,2.14,0,0,0,12,15.39a2.12,2.12,0,0,0,1.54.66,2.14,2.14,0,0,0,1.55-.66,2.12,2.12,0,0,0,1.54.66,2.18,2.18,0,0,0,1.55-.66,2.12,2.12,0,0,0,1.54.66.34.34,0,1,0,0-.68,1.48,1.48,0,0,1-1.25-.7A4.13,4.13,0,0,0,20.07,11.41Z",
    style: {
      fill: '#fff'
    }
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "15.6",
    y: "7.98",
    width: "1.37",
    height: "0.69",
    style: {
      fill: '#fff'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7,7.29A.34.34,0,0,0,7.36,7V6.61a.34.34,0,1,0-.68,0V7A.34.34,0,0,0,7,7.29Z",
    style: {
      fill: '#fff'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.68,8.67a.34.34,0,0,0,.68,0V8.32a.34.34,0,0,0-.68,0Z",
    style: {
      fill: '#fff'
    }
  }));
};

exports["default"] = _default;